// Generated by CoffeeScript 2.7.0
var PopoverFieldSelect;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import {
  PopoverGroupOptionsMixin
} from 'trunks/vue/admin/components/popover_group_options.js';

export default PopoverFieldSelect = Vue.extend({
  mixins: [PopoverGroupOptionsMixin],
  components: {
    'Popover': Popover
  },
  props: {
    extendClass: {
      type: String
    },
    initialSelectedOptionIds: {
      type: Array,
      default: function() {
        return [];
      }
    },
    formatDataFunc: {
      type: Function,
      required: true
    }
  },
  data: function() {
    return {
      selectedOptionIds: this.initialSelectedOptionIds
    };
  },
  template: `<Popover position='bottom'
         type='select'
         size='normal'
         :caret='false'a
         :blockContent='true'
         :manualToggle='true'
         :customClass='extendClass'
         @triggerClicked='triggerClicked'
         ref='popoverVm'>
  <template slot='trigger'>
    <slot name='trigger'></slot>
  </template>
  <template slot='content'>
    <popover-group-options wrapperClass="fields-edit-container"
                           optionsFilterPlaceholder='搜索字段'
                           :initialSelectedOptionIds='selectedOptionIds'
                           :formatDataFunc='formatDataFunc'
                           ref='popoverGroupOptionsRef'
                           @cancelClicked='closeFunc'
                           @submitClicked='submitFunc'
                           @valueChanged='valueChangedFunc'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <slot name='option-item-template' :option='option'>
        </slot>
      </template>

      <div slot='filter-blankslate' class='list-group'>
        <slot name='filter-blankslate'></slot>
      </div>

      <div slot='options-blankslate' class='list-group'>
        <slot name='options-blankslate'></slot>
      </div>
    </popover-group-options>
  </template>
</Popover>`,
  watch: {
    initialSelectedOptionIds: function(new_value) {
      var ref;
      this.selectedOptionIds = new_value;
      return (ref = this.$refs.popoverGroupOptionsRef) != null ? ref.selectedOptionsChanged(this.selectedOptionIds) : void 0;
    }
  },
  methods: {
    triggerClicked: function() {
      return this.$refs.popoverVm.open();
    },
    valueChangedFunc: function(new_option) {
      return this.selectedOptionIds = new_option._selected ? _.union(this.selectedOptionIds, [new_option.id]) : _.without(this.selectedOptionIds, new_option.id);
    },
    closeFunc: function() {
      this.reset();
      return this.$refs.popoverVm.close();
    },
    getSelectedGroupOptions: function() {
      var result, selected_ids;
      result = [];
      selected_ids = this.selectedOptionIds;
      _.each(this.formatDataFunc(), function(group) {
        var _group;
        _group = _.clone(group);
        _group.options = _.filter(group.options, function(option) {
          return _.contains(selected_ids, option.id);
        });
        if (_group.options.length) {
          return result.push(_group);
        }
      });
      return result;
    },
    submitFunc: function() {
      this.$emit('submitClicked', {
        groups: this.getSelectedGroupOptions(),
        option_ids: this.selectedOptionIds
      });
      return this.closeFunc();
    }
  }
});
